import React, { useEffect, useState } from "react";
import { useSelector,useDispatch } from "react-redux";
import { Button, Typography, Box, Chip, Grid, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import SelectParty from "components/party/components/SelectParty";
import {setAddOrderStoryState} from "store/slice/AppSlice";
import {setPharmaorderAddorderModal, setPharmaorderManageProductsModal} from "store/slice/PharmaSlice";
import { canOrderBeCreatedAPI } from "api/OmsOrdermgmtWebServices";
import {setErrMsg, clearErrMsg} from "store/slice/AppSlice";
import { setSelectedProductId, setSelectedCompositiontemplateId } from "store/slice/PharmaSlice";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function SubmitOrderConfirmation() {
  const dispatch = useDispatch()
  const { partyList } = useSelector((state) => state.pharmaslice.partyDashboard);
  const [partyId, setPartyId] = useState(null);
  const {partyObj} = useSelector((state) => state.pharmaslice.partyDashboard);
  const { addOrderStory } = useSelector((state) => state.appslice);
  const {errMsg} = useSelector((state) => state.appslice);
  const { pharmaorderObj } = useSelector((state) => state.pharmaslice.pharmaorderDashboard);

  const handleClose = () => {
    dispatch(setPharmaorderManageProductsModal(false));
    dispatch(setPharmaorderAddorderModal(false));
  }
  return (
    <>
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          width: { xs: '100%', sm: '80%', md: '60%' },
          mt: 4,
          mb: 2,
          backgroundColor: 'white',
          padding: 5,
          borderRadius: 2,
          boxShadow: 3,
          mx: "auto",
          minHeight: 120,
          textAlign: "center", // Ensures text is centered
        }}
      >
        <CheckCircleIcon
          sx={{
            fontSize: 48,
            color: 'success.main',
            bgcolor: 'success.lighter',
            borderRadius: '50%',
            mb: 2,
            borderColor: 'success.main',
          }}
        />
        <Typography
          variant="h5"
          sx={{
            color: 'success.main',
            fontWeight: 'bold',
            width: "100%",
            textAlign: "center", // Ensures text is centered on all screens
            wordBreak: "break-word",
            whiteSpace: "normal",
            overflowWrap: "break-word",
          }}
        >
          Order # {pharmaorderObj.id} is submitted for approval.
        </Typography>
      </Grid>

      <Grid lg={12} xs={12} item sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", width: "100%", mt: 2 }}>
        <Button variant="contained"  sx={{ mr: 2 }} onClick={handleClose}>
          Close
        </Button>
      </Grid>
    </>
  );
}